import { enableApiMocks } from "@settings";

export const enableMocking = async () => {
  if (!enableApiMocks) return;

  const { worker } = await import("./browser");
  return worker.start();
};
